module.exports = __webpack_public_path__ + "img/question-mark.96f2303d.svg";